import { render, staticRenderFns } from "./BottomPanel.vue?vue&type=template&id=dfb67cf8&scoped=true&"
import script from "./BottomPanel.vue?vue&type=script&lang=js&"
export * from "./BottomPanel.vue?vue&type=script&lang=js&"
import style0 from "./BottomPanel.vue?vue&type=style&index=0&id=dfb67cf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb67cf8",
  null
  
)

export default component.exports